module.exports = __webpack_public_path__ + "static/media/flag-us-round.bc90ea65.png";